import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  forgotPassword: {
    margin: "50px 0 50px",
  },
}));
